import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import VirusBeaconClient from '../../clients/VirusBeaconClient';
import stateDiseases from '../../state/stateDiseases';
import stateInterProcs from '../../state/stateInterProcs';
import stateMeasures from '../../state/stateMeasures';

function useBeaconFilters() {
  const [diseases, setDiseases] = useRecoilState(stateDiseases);
  const [interProcs, setInterProcs] = useRecoilState(stateInterProcs);
  const [measures, setMeasures] = useRecoilState(stateMeasures);
  const [search, setSearch] = useState(0 as number);

  useEffect(() => {
    if (0 === interProcs.length && search === 0) {
      const abortController = new AbortController();
      setSearch(1);
      (async () => {
        try {
          const filteringTerms = await VirusBeaconClient.getFilteringTerms(
            abortController.signal
          );

          if (0 === diseases.length) {
            const diseases = filteringTerms.filter((elem) =>
              elem.id.startsWith('ICD10CM')
            );
            setDiseases(diseases);
          }

          if (0 === interProcs.length) {
            const interProcs = filteringTerms.filter((elem) =>
              elem.id.startsWith('ICD10PCS')
            );
            setInterProcs(interProcs);
          }
          if (0 === measures.length) {
            const measures = filteringTerms.filter((elem) =>
              elem.id.startsWith('LOINC')
            );
            setMeasures(measures);
          }
        } catch (error) {
          if (!abortController.signal.aborted) {
            // error!
            console.log('ERROR: ' + error);
          }
        }
      })();

      return () => {
        abortController.abort();
      };
    } else {
      return () => {};
    }
  }, [interProcs]);
}

export default useBeaconFilters;
